import { render, staticRenderFns } from "./Conexion.vue?vue&type=template&id=23849f3b"
import script from "./Conexion.vue?vue&type=script&lang=js"
export * from "./Conexion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports